import { cartActionsStyles } from "@waytek/Overrides/Widgets/Cart/CartActions";
import { css } from "styled-components";

cartActionsStyles.saveOrderButton = {
    ...cartActionsStyles.saveOrderButton,
    css: css`
        display: none;
    `,
};

cartActionsStyles.saveOrderClickable = {
    ...cartActionsStyles.saveOrderClickable,
    css: css`
        display: none;
    `,
};
